export default "__VITE_ASSET__BbhvyJby__"